module.exports = __webpack_public_path__ + "static/ohs-de31b0af6d947fce0ce44735ff686a90.jpg";